import React from 'react';
import { PiHammerDuotone, PiWarningCircleFill } from 'react-icons/pi';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';

interface MyTutorialsProps { }

const MyTutorials: React.FC<MyTutorialsProps> = () => {
    const breadCrumb = [
        { name: 'Panel de control del tutor' },
        { name: 'Mis tutorías', href: menuRoutes.tutor_panel.tutorials },
    ];

    return (
        <>
            <PageHeader title="Mis tutorías" breadcrumb={breadCrumb} />

            <section className="mt-6 overflow-hidden rounded-lg border-2 border-amber-300 bg-amber-50">
                <div className="border-b border-amber-200 bg-amber-100/80 px-6 py-4">
                    <div className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-3 py-1 text-sm font-semibold text-white">
                        <PiWarningCircleFill className="h-4 w-4" />
                        Sección en desarrollo
                    </div>
                </div>

                <div className="flex min-h-[320px] flex-col items-center justify-center px-6 py-12 text-center sm:px-10">
                    <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-white text-amber-500 shadow-sm ring-1 ring-amber-200">
                        <PiHammerDuotone className="h-10 w-10" />
                    </div>

                    <h2 className="text-2xl font-semibold text-gray-900 sm:text-3xl">
                        Estamos trabajando en esta pantalla
                    </h2>

                    <p className="mt-4 max-w-2xl text-base leading-7 text-gray-700">
                        La sección <strong>Mis tutorías</strong> todavía no está disponible.
                        Su contenido y funcionalidades se encuentran en desarrollo.
                    </p>
                </div>
            </section>
        </>
    );
};

export default MyTutorials;
